export default "__VITE_ASSET__D17F86Gd__"